import { gmailPromotionTabWhitelistSchema } from "@redotech/redo-marketing-core-common/gmail-promotion-tab-whitelist";
import * as z from "zod";

export const getGmailPromotionTabWhitelistStatus = {
  name: "getGmailPromotionTabWhitelistStatus" as const,
  input: z.object({ domain: z.string() }),
  output: gmailPromotionTabWhitelistSchema.nullable(),
};
